import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { AdminAuthService } from '../../admin/admin-auth.service';
import { environment as ENV } from 'environments/environment';

import { TokenServiceService } from 'app/token-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import * as constants from "../../constant";
import { OpenAdminDialogYesOrNo } from 'app/admin/admin-yes-or-no/admin-yes-or-no.component';
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';
import { LoginOtpDialogComponent } from '../login-otp-dialog/login-otp-dialog.component';

@Component({
  selector: 'wl-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.scss'],

})
export class LoginAdminComponent implements OnInit {

  adminForm: UntypedFormGroup;
  loginAs: string;
  level: string;
  showPassword: boolean = false;
  typeType: string = 'password';

  private pendingAdmin: any = null;
  isOtpDialogOpen: boolean = false;
  isErrorDialogOpen: boolean = false;
  isLoading: boolean = false;
  loadingText: string = '';

  loginView: string = 'login'; // 'login' | 'unlock-step1' | 'unlock-step2'
  isAccountBlocked: boolean = false;
  staleAccountMessage: string = '';
  sessionExpiredMsg: string = '';
  maskedContact: string = '';
  unlockStaffId: string = '';
  unlockOtp: string = '';
  unlockError: string = '';
  unlockOtpDigits: string[] = ['', '', '', '', '', ''];
  unlockResendDisabled: boolean = true;
  unlockOtpBlocked: boolean = false;
  unlockTimer: number = 30;
  private unlockTimerInterval: any;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private adminAuth: AdminAuthService,
    private token: TokenServiceService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) {
    this.adminForm = this.fb.group({
      staffId: ['', Validators.required],
      badWord: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])[\S]{8,24}$/)]],
    })
  }

  ngOnInit() {
    this.token.setState('random');
    let selectedState = '';
    this.token.selectedstateCode.subscribe(value => { selectedState = value });

    const expMsg = sessionStorage.getItem('wl-session-expired-msg');
    if (expMsg) {
      this.sessionExpiredMsg = expMsg;
      sessionStorage.removeItem('wl-session-expired-msg');
    }

    if (this.adminAuth.adminLoggedIn()) {
      this.router.navigate(['/admin']);
    }
  }

  adminLogin(company) {
    console.log("payload : ",company);

    this.isLoading = true;
    this.loadingText = 'logging in...';

    company.mobileNo = company.staffId
    this.adminAuth.adminLogin(company.staffId, company.badWord, company.mobileNo).subscribe
    (res => {
      console.log('Admin Login: ', res);

      this.pendingAdmin = res;

      console.log('role id we need', res.roleId);
      sessionStorage.setItem('getroleId', res.roleId);
      sessionStorage.setItem('getuserId', res.id);
      console.log(res);
      let userRoleId = res.roleId;
      if (userRoleId == '1') {
        this.level = 'Central Office'
        sessionStorage.setItem("DbBEXZNoIA", "YuPSie");//enable clicks
      } else if (userRoleId == '2') {
        this.level = 'Zonal Admin'
        sessionStorage.removeItem('DbBEXZNoIA');
      } else if (userRoleId == '3') {
        this.level = 'Regional Admin'
        sessionStorage.removeItem('DbBEXZNoIA');
      } else if (userRoleId == '4') {
        this.level = 'Branch Admin'
        sessionStorage.setItem("DbBEXZNoIA", "YuPSie");//enable clicks
      } else if (userRoleId == '11') {
        this.level = 'Maker'
        sessionStorage.removeItem('DbBEXZNoIA');
      } else if (userRoleId == '12') {
        this.level = 'Checker'
        sessionStorage.removeItem('DbBEXZNoIA');
      } else if (userRoleId == '21') {
        this.level = 'Zone User'
        sessionStorage.removeItem('DbBEXZNoIA');
      } else if (userRoleId == '31') {
        this.level = 'Regional User'
        sessionStorage.removeItem('DbBEXZNoIA');
      } else if (userRoleId == '41') {
        this.level = 'Branch User'
        sessionStorage.removeItem('DbBEXZNoIA');
      } else if (userRoleId == '0') {
        this.level = 'Super Admin';
        sessionStorage.setItem("DbBEXZNoIA", "YuPSie");//enable clicks
      } else if (userRoleId == '5') {
        this.level = 'rdo';
        sessionStorage.setItem("DbBEXZNoIA", "YuPSie");//enable clicks
      }
      if (res) {
        switch (res.roleId) {
          case 0:
            sessionStorage.setItem('wzbvdsjvbbs', '0f45789q-4467-423d-b097-a80ccca0d435');
            // window.alert("role 0")
            break;

          case 1:
            sessionStorage.setItem('wzbvdsjvbbs', '19a75802-4467-423d-b097-a80ccca0d436');
            break;

          case 2:
            sessionStorage.setItem('wzbvdsjvbbs', '2b5ef3fd-9be4-4d41-b84b-b551180c9803');
            break;

          case 3:
            sessionStorage.setItem('wzbvdsjvbbs', '39161102-ccb7-11ea-87d0-0242ac130003');
            break;

          case 4:
            sessionStorage.setItem('wzbvdsjvbbs', '4dfb05e4-ca35-492b-8a6a-0e0775426090');
            break;

          case 5:
            sessionStorage.setItem('wzbvdsjvbbs', '5b8f43f6-9ae5-4642-8939-310771661e4f');
            break;

          case 6:
            sessionStorage.setItem('wzbvdsjvbbs', '6a66230a-ccbf-11ea-87d0-0242ac130003');
            break;

          case 7:
            sessionStorage.setItem('wzbvdsjvbbs', '7a66230a-ccbf-12bd-87d0-0242ac130003');
            break;

          default:

        }
      }
      sessionStorage.setItem('stateCode', res.state)
      this.token.setState(res.state)
      let selectedState = ''
      this.token.selectedstateCode.subscribe(value => { selectedState = value })
      console.log(selectedState);

      if (!(res.roleId == 0 || res.roleId == 1)) {
        if (constants.STATES.MP.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.MP.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.MP.KEY);

        } else if (constants.STATES.KA.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.KA.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.KA.KEY);

        } else if (constants.STATES.UP.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.UP.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.UP.KEY);

        } else if (constants.STATES.OD.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.OD.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.OD.KEY);

        }else if (constants.STATES.TN.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.TN.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.TN.KEY);

        }else if (constants.STATES.AD.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.AD.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.AD.KEY);

        } else if (constants.STATES.RJ.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.RJ.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.RJ.KEY);

        } else if (constants.STATES.GJ.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.GJ.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.GJ.KEY);
        } else if (constants.STATES.MH.POSSIBILITIES.includes(res.state.toLowerCase())) {
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.MH.KEY);
          sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.MH.KEY);
        }
        
        
        else {
          this.snackbar.open("State information not found or doesn't match", "OK", { duration: 10000 })
          return
        }
      }

      // this.router.navigate(['/admin/landing1']);

      this.adminAuth.generateUserOtp(company.staffId).subscribe(

  otpRes => {
      this.isLoading = false;
      this.isOtpDialogOpen = true;
      const dialogRef = this.dialog.open(LoginOtpDialogComponent, {
        width: '450px',
        panelClass: 'otp-dialog-container',

        disableClose: true,
        data: {
          staffId: company.staffId,
          otpResponse: otpRes
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        this.handleOtpDialogResult(result, company, otpRes);
      });

    },
    otpErr => {
      this.loadingText = '';
      let errMsg = '';

      if (otpErr && otpErr.status === '30_SECONDS_COOLDOWN') {
        errMsg = otpErr.message || 'Please wait 30 seconds before requesting another OTP.';
      } else if (otpErr && otpErr.status === 'OTP_GEN_BLOCKED') {
        errMsg = otpErr.message || 'OTP generation blocked. Please try again later.';
      } else {
        errMsg = otpErr.message || 'Failed to generate OTP.';
      }

      const errRef = this.dialog.open(OpenDialogYesOrNo, {
        width: 'auto',
        height: 'auto',
        disableClose: true,
        data: {
          content1: errMsg,
          button1Text: 'OK'
        }
      });
      errRef.afterClosed().subscribe(() => {
        this.isLoading = false;
      });

    }
  );
},
    
    err => {
      this.isLoading = false;
      console.log('API ERROR BODY:', err);

      if (err.message === 'newuser') {
        this.isErrorDialogOpen = true;
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          data: {
            content1:
              "You are logging in for the first time. For security reasons, you must reset your password before continuing.",
            button1Text: "Reset"
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          this.isErrorDialogOpen = false;
          if (result === "dontClose") {
            this.router.navigate(['/reset-password']);
          } else {
            this.isLoading = true;
            this.loadingText = 'Redirecting to login...';
            setTimeout(() => {
              this.isLoading = false;
              this.adminForm.reset();
            }, 1000);
          }
        });

        return;
      }
      else if (err.message === 'User account is - blocked') {
        this.isAccountBlocked = true;
        this.unlockStaffId = company.staffId;
        return;
      }
      else if (err.message && err.message.includes('deactivated due to prolonged inactivity')) {
        this.staleAccountMessage = 'Your account has been deactivated due to prolonged inactivity. Please contact your System Administrator.';
        return;
      }
      else if(err.message === 'Current Password has been expired.Please update the password'){
        this.isErrorDialogOpen = true;
        const dialogRef=this.dialog.open(OpenDialogYesOrNo,{
          width :'auto',
          height: 'auto',
          data:{
            content1: err.message? err.message : "Current Password has been expired.Please update the password",
            button1Text:"Reset"
          }
        })
        dialogRef.afterClosed().subscribe(result=>{
          this.isErrorDialogOpen = false;
          if(result === "dontClose"){
            this.router.navigate(['/reset-password']);
          } else {
            this.isLoading = true;
            this.loadingText = 'Redirecting to login...';
            setTimeout(() => {
              this.isLoading = false;
              this.adminForm.reset();
            }, 1000);
          }
        })
        return;
      }
      else if(err.message === 'An active session already exists for your account. Please end your existing session or wait for it to expire before logging in again.'){
        this.isErrorDialogOpen = true;
        const dialogRef=this.dialog.open(OpenDialogYesOrNo,{
          width :'auto',
          height: 'auto',
          data:{
            content1: err.message? err.message : "An active session already exists for your account. Please end your existing session or wait for it to expire before logging in again.",
            button1Text:"ok"
          }
        })
        dialogRef.afterClosed().subscribe(() => {
          this.isErrorDialogOpen = false;
          this.isLoading = true;
          this.loadingText = 'Redirecting to login...';
          setTimeout(() => {
            this.isLoading = false;
            this.adminForm.reset();
          }, 1000);
        });
        return;
      }
      else if(err.message === 'Your account is blocked due to multiple failed MFA attempts. Please try again after 24 hours.'){
        this.isErrorDialogOpen = true;
        const dialogRef=this.dialog.open(OpenDialogYesOrNo,{
          width :'auto',
          height: 'auto',
          data:{
            content1: err.message? err.message : "Your account is blocked due to multiple failed MFA attempts. Please try again after 24 hours.",
            button1Text:"ok"
          }
        })
        dialogRef.afterClosed().subscribe(() => {
          this.isErrorDialogOpen = false;
          this.isLoading = true;
          this.loadingText = 'Redirecting to login...';
          setTimeout(() => {
            this.isLoading = false;
            this.adminForm.reset();
          }, 1000);
        });
        return;
      }
      else if (err.message ==='User account is - disabled'){
        this.isErrorDialogOpen = true;
        const dialogRef=this.dialog.open(OpenDialogYesOrNo,{
          width :'auto',
          height: 'auto',
          data:{
            content1: "Your account has been deactivated due to prolonged inactivity. Please contact your System Administrator.",
            button1Text:"ok"
          }
        })
        dialogRef.afterClosed().subscribe(() => {
          this.isErrorDialogOpen = false;
          this.isLoading = true;
          this.loadingText = 'Redirecting to login...';
          setTimeout(() => {
            this.isLoading = false;
            this.adminForm.reset();
          }, 1000);
        });
        return;

      }

          this.snackbar.open("PF No or Password is incorrect, please enter the valid details", 'OK', { duration: 3000 });
          console.log(err);
    });
  
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.typeType = this.showPassword ? 'text' : 'password';
  }

  showUnlockFlow() {
    this.unlockStaffId = this.adminForm.value.staffId;
    this.unlockError = '';
    this.submitRequestUnlock();
  }

  handleOtpDialogResult(result: any, company: any, otpRes: any) {
    this.isOtpDialogOpen = false;

    if (result && result.status === 'resend') {
      this.isLoading = true;
      this.loadingText = 'Resending OTP...';
      this.adminAuth.generateUserOtp(company.staffId).subscribe(
        res => {
          this.isLoading = false;
          if (res && res.success) {
            this.openOtpDialog(company, res);
          } else {
            this.openOtpDialog(company, otpRes, res.message || 'Failed to resend OTP.');
          }
        },
        err => {
          this.isLoading = false;
          this.openOtpDialog(company, otpRes, err.message || 'Failed to resend OTP.');
        }
      );
      return;
    }

    if (result && result.status === 'verifying') {
      this.isLoading = true;
      this.loadingText = 'Verifying OTP...';
      this.adminAuth.verifyuserotp(company.staffId, result.otp).subscribe(
        res => {
          if (res && res.success) {
            this.loadingText = 'Logging in...';
            const adminData = { ...this.pendingAdmin };
            if (res.access_token) adminData.accessToken = res.access_token;
            this.adminAuth.finalizeLogin(adminData);
            this.adminAuth.broadcastNewLogin();
            this.pendingAdmin = null;
            this.router.navigate(['/admin/landing1']);
          } else {
            this.isLoading = false;
            this.openOtpDialog(company, otpRes, res.message || 'Invalid OTP');
          }
        },
        err => {
          if (err && err.session_exists) {
            // Active session exists - ask user to terminate or cancel
            this.isLoading = false;
            this.isErrorDialogOpen = true;
            const sessionAccessToken = err.access_token || null;
            const sessionRef = this.dialog.open(OpenDialogYesOrNo, {
              width: 'auto',
              height: 'auto',
              disableClose: true,
              data: {
                content1: 'An active session already exists for your account. Do you want to terminate the previous session and continue here?',
                button1Text: 'Yes',
                button2Text: 'No'
              }
            });
            sessionRef.afterClosed().subscribe(sessionResult => {
              this.isErrorDialogOpen = false;
              if (sessionResult === 'dontClose') {
                // User clicked Yes - terminate previous session
                this.isLoading = true;
                this.loadingText = 'Logging in...';
                this.adminAuth.terminateSession(this.pendingAdmin.id).subscribe(
                  () => {
                    const adminData = { ...this.pendingAdmin };
                    // access_token from terminate response is already stored by the service
                    if (sessionAccessToken) adminData.accessToken = sessionAccessToken;
                    this.adminAuth.finalizeLogin(adminData);
                    this.adminAuth.broadcastNewLogin();
                    this.pendingAdmin = null;
                    this.router.navigate(['/admin/landing1']);
                  },
                  termErr => {
                    this.isLoading = false;
                    this.isErrorDialogOpen = true;
                    const errRef = this.dialog.open(OpenDialogYesOrNo, {
                      width: 'auto',
                      height: 'auto',
                      disableClose: true,
                      data: {
                        content1: 'Failed to login. Please try again.',
                        button1Text: 'OK'
                      }
                    });
                    errRef.afterClosed().subscribe(() => {
                      this.isErrorDialogOpen = false;
                      this.pendingAdmin = null;
                      this.adminForm.reset();
                    });
                  }
                );
              } else {
                // User clicked No - go back to login
                this.isLoading = true;
                this.loadingText = 'Redirecting to login...';
                this.pendingAdmin = null;
                setTimeout(() => {
                  this.isLoading = false;
                  this.adminForm.reset();
                }, 1000);
              }
            });
          } else if (err && err.status && err.status === 'blocked') {
            this.pendingAdmin = null;
            this.isLoading = true;
            this.loadingText = '';
            const blockedRef = this.dialog.open(OpenDialogYesOrNo, {
              width: 'auto',
              height: 'auto',
              disableClose: true,
              data: {
                content1: err.message || 'Maximum incorrect attempts reached. Your account is locked. Please self-unlock.',
                button1Text: 'OK'
              }
            });
            blockedRef.afterClosed().subscribe(() => {
              this.loadingText = 'Redirecting to login...';
              setTimeout(() => {
                this.isLoading = false;
                this.loginView = 'login';
                this.isAccountBlocked = false;
                this.adminForm.reset();
              }, 2000);
            });
          } else {
            this.isLoading = false;
            this.openOtpDialog(company, otpRes, err.message || 'Verification failed');
          }
        }
      );
      return;
    }

    this.pendingAdmin = null;
  }

  openOtpDialog(company: any, otpRes: any, errorMsg?: string) {
    this.isOtpDialogOpen = true;
    const ref = this.dialog.open(LoginOtpDialogComponent, {
      width: '450px',
      panelClass: 'otp-dialog-container',
      disableClose: true,
      data: { staffId: company.staffId, otpResponse: otpRes, errorMsg: errorMsg || '' }
    });
    ref.afterClosed().subscribe(r => {
      this.handleOtpDialogResult(r, company, otpRes);
    });
  }

  backToLogin() {
    this.isLoading = true;
    this.loadingText = 'Redirecting to login...';

    setTimeout(() => {
      this.isLoading = false;
      this.loginView = 'login';
      this.isAccountBlocked = false;
      this.unlockStaffId = '';
      this.unlockOtp = '';
      this.unlockError = '';
      this.adminForm.reset();
    }, 1000);
  }

  submitRequestUnlock() {
    if (!this.unlockStaffId) return;
    this.isLoading = true;
    this.loadingText = 'Sending OTP...';
    this.unlockError = '';
    console.log("unlockStaffId is ", this.unlockStaffId);
    
    this.adminAuth.requestUnlock(this.unlockStaffId).subscribe(
      res => {
        this.isLoading = false;
        this.maskedContact = (res.result && res.result.maskedContact)
          ? res.result.maskedContact
          : (res.message || 'your registered mobile number');
        this.loginView = 'unlock-step2';
        this.startUnlockTimer();
      },
      err => {
        this.loadingText = '';
        const errorRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          disableClose: true,
          data: {
            content1: err.message || 'Failed to send OTP. Please try again.',
            button1Text: 'OK'
          }
        });
        errorRef.afterClosed().subscribe(() => {
          this.loadingText = 'Redirecting to login...';
          setTimeout(() => {
            this.isLoading = false;
            this.loginView = 'login';
            this.isAccountBlocked = false;
            this.unlockStaffId = '';
            this.unlockOtp = '';
            this.unlockError = '';
            this.adminForm.reset();
          }, 1000);
        });
      }
    );
  }

  submitVerifyUnlockOtp() {
    if (!this.unlockOtp) return;
    this.isLoading = true;
    this.loadingText = 'Verifying OTP...';
    this.unlockError = '';
    this.adminAuth.verifyUnlockOtp(this.unlockStaffId, this.unlockOtp).subscribe(
      () => {
        this.isLoading = false;
        this.isErrorDialogOpen = true;
        const successRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          disableClose: true,
          data: {
            content1: 'Your account has been unlocked successfully. Please log in.',
            button1Text: 'OK'
          }
        });
        successRef.afterClosed().subscribe(() => {
          this.isErrorDialogOpen = false;
          this.isLoading = true;
          this.loadingText = 'Redirecting to login...';
          setTimeout(() => {
            this.isLoading = false;
            this.loginView = 'login';
            this.isAccountBlocked = false;
            this.unlockStaffId = '';
            this.unlockOtp = '';
            this.unlockOtpDigits = ['', '', '', '', '', ''];
            this.adminForm.reset();
          }, 1000);
        });
      },
      err => {
        this.isLoading = false;
        this.unlockError = err.message || 'Invalid OTP. Please try again.';
        if (err.message && err.message.includes('Too many invalid OTP attempts' || 'OTP generation limit reached. You can request again after 24 hours')) {
          this.unlockOtpBlocked = true;
        }
      }
    );
  }

  //   onOtpKeydown(index: number, event: KeyboardEvent, prevEl: HTMLInputElement) {
  //   if (event.key === 'Backspace' && !this 0.otpDigits[index] && prevEl) {
  //     prevEl.focus();
  //   }
  // }

    get allUnlockOtpDigitsFilled(): boolean {
    return this.unlockOtpDigits.every(d => d !== '');
  }

  onUnlockOtpInput(index: number, event: any, nextEl: HTMLInputElement) {

    const digit = event.target.value.replace(/\D/g, '').slice(-1);

    event.target.value = digit;

    const updated = [...this.unlockOtpDigits];

    updated[index] = digit;

    this.unlockOtpDigits = updated;

    this.unlockOtp = this.unlockOtpDigits.join('');

    if (digit && nextEl) {
      nextEl.focus();
    }
  }

  onUnlockOtpKeydown(index: number, event: KeyboardEvent, prevEl: HTMLInputElement) {

    if (event.key === 'Backspace' && !this.unlockOtpDigits[index] && prevEl) {
      prevEl.focus();
    }
  }

  startUnlockTimer() {

  clearInterval(this.unlockTimerInterval);

  this.unlockResendDisabled = true;

  this.unlockTimer = 30;

  this.unlockTimerInterval = setInterval(() => {

    this.unlockTimer--;

    if (this.unlockTimer <= 0) {

      clearInterval(this.unlockTimerInterval);

      this.unlockResendDisabled = false;
    }

  }, 1000);
}

  resendUnlockOtp() {

  if (this.unlockResendDisabled) {
    return;
  }

  this.unlockError = '';
  this.unlockOtpBlocked = false;
  this.isLoading = true;
  this.loadingText = 'Resending OTP...';

  setTimeout(() => {
    this.adminAuth.requestUnlock(this.unlockStaffId).subscribe(

      res => {
        this.isLoading = false;

        this.maskedContact = (res.result && res.result.maskedContact)
          ? res.result.maskedContact
          : (res.message || 'your registered mobile number');

        this.unlockOtp = '';

        this.unlockOtpDigits = ['', '', '', '', '', ''];

        this.startUnlockTimer();
      },

      err => {
        this.isLoading = false;

        this.unlockError =
          err.message || 'Failed to resend OTP. Please try again.';
      }

    );
  }, 1000);
}
}
